import React from 'react'
import Loadable from 'react-loadable'
import Loading from '../common/Loading'

const App = Loadable({
  loader: () => import('./Form'),
  loading: Loading
})

export default props => <App { ...props } />
